import { COMMERCIAL, PERSONAL } from "../../constants/keys";
import {
  SET_CAN_ADVANCE,
  CLEAR_FORM,
  SET_POLICY_NUMBER,
  SET_TYPE_OF_CLAIM,
  SEND_AUTO_FORM,
  SEND_PROPERTY_FORM,
  RESET_INITIAL_STATE,
  SET_POLICY_TYPE_TOGGLE,
  SET_URL_PARAMS_TO_REGISTER,
  SET_ATTACHMENT_FAILURES,
  } from "../actions/anonymousForms";

const initialState = {
  canAdvance: true,
  clearForm: { auto: false, property: false },
  glForm: {},
  policyNumber: "",
  referenceNumber: "",
  typeOfClaim: "choosing",
  vehicleForm: {},
  policyTypeToggle: [
    { label: PERSONAL, selected: true },
    { label: COMMERCIAL, selected: false },
  ],
  urlParamsToRegister: {
    policyNumber: "",
    name: "",
    phone: "",
    email: "",
  },
  attachmentFailures: [],
};

export const anonymousFormsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAN_ADVANCE:
      return { ...state, canAdvance: action.canAdvance };
    case SET_POLICY_NUMBER:
      return { ...state, policyNumber: action.policyNumber };
    case SET_TYPE_OF_CLAIM:
      return { ...state, typeOfClaim: action.claimType };
    case SET_POLICY_TYPE_TOGGLE:
      return { ...state, policyTypeToggle: action.toggle };
    case SEND_AUTO_FORM:
      return { ...state, referenceNumber: action.referenceNumber };
    case SEND_PROPERTY_FORM:
      return { ...state, referenceNumber: action.referenceNumber };
    case CLEAR_FORM:
      return { ...state, clearForm: action.clear };
    case SET_URL_PARAMS_TO_REGISTER:
      return { ...state, urlParamsToRegister: action.urlParamsToRegister };
    case SET_ATTACHMENT_FAILURES:
      return { ...state, attachmentFailures: action.attachmentFailures };
    case RESET_INITIAL_STATE:
      return { ...initialState };
    default:
      return { ...state };
  }
};
